module.exports = __webpack_public_path__ + "static/Pasien-23f6e3fd675f89e0a954a47f96024833.png";